/* eslint-disable no-param-reassign */
import { MessageState, RootState } from '@/store/types';
import { Module } from 'vuex';

export default {
  namespaced: true,
  state: {
    title: '',
    message: '',
    connectionIssue: false
  },
  mutations: {
    resetMessage(state) {
      state.title = '';
      state.message = '';
      state.connectionIssue = false;
    },
    pushMessage(state, { title, message, error, humanMessage, connectionIssue }) {
      state.title = title;
      state.connectionIssue = connectionIssue;
      const oldMessage = state.message;
      state.message = humanMessage || `${error}: ${message}`;
      if (oldMessage === state.message) {
        state.message += ' '; // Force change, Vue is too intelligent
      }
    }
  }
} as Module<MessageState, RootState>;
